import './ai-chat-popup.css';
import {requestAnimationFrame} from 'CommonUtils/raf.js';
import {sessionLoad } from '../../storageService';



let chat_history = ``;
let load_chat_history = sessionLoad('chatAi_chat_history') || {};


if (Object.keys(load_chat_history).length > 0) {
    const keys = Object.keys(load_chat_history);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const isLast = i === keys.length - 1;

        // Skip the last key if it includes 'q'
         if (isLast && key.includes('q')) continue;

            chat_history += key.includes('q')
            ? `<li class="user"><p>
                    <span class="name"></span>
                    <span class="text">${load_chat_history[key]}</span>
                </p></li>`
            : `<li class="ai"><p>
                    <span class="name"></span>
                    <span class="text">${load_chat_history[key]}</span>
                </p></li>`;

        
    }
}



const chat_popup = document.createElement('div');
chat_popup.id = 'ai-chat-popup';
chat_popup.className = ' animateHeight'; // Optional: add a class


chat_popup.innerHTML = `
    <div class="ai-chat-popup-inner">
        <div id='ai-chat-bubble-close' class='aiChatToggle'>
            <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="14" height="14" fill="none" stroke="#2f2f2f" stroke-width="1"/>
                <rect x="3" y="7" width="9" height="1" fill="#2f2f2f"/>
            </svg>
        </div>
        <div class="ai-chat-popup-title">
            <div class="assistant-btn"></div>
            <h2>iFOREX AI</h2>
        </div>
        <div class="ai-chat-popup-body">
            <p>Hey there!<span>👋</span><br>I’m iFOREX AI, your personal trading knowledge assistant. I’m here to instantly answer your questions and guide you through your trading journey. Using this tool is subject to the following <span id="ai-disclaimer-open" class="disclaimerContentToggle">disclaimer</span>.</p>
            <p>How can I assist you today? Ask me anything or start with one of these popular questions:</p>
            <div id="ai-chat-popup-questions">
                <div id="ai-q1" class="ai-question" data-question="Who is the iFOREX Group?">Who is the iFOREX Group?</div>
                <div id="ai-q2" class="ai-question" data-question="How can I start trading?">How can I start trading?</div>
                <div id="ai-q3" class="ai-question" data-question="Are you regulated?">Are you regulated?</div> 
            </div>
            <div class="chat-ai" id="chat-ai">
                <ul id="all-messages">${chat_history}</ul>
            </div>
        </div>
    
        
        <div id="ai-chat-popup-footer">
            <div class="ai-question-input-wrapper" id="ai-input-wrapper">
                <div class="ai-question-input-inner-wrapper" >
                    <input type="text" placeholder="Ask iForex AI..." id="ai-question-input" autocomplete="off" />
                <div class="submit-question-btn" id="ai-submit"></div>
                </div>
            </div>
            <p class="mt-2">Powered by OpenAI <span id="ai-disclaimer-open" class="disclaimerContentToggle">Disclaimer</span></p>
            
            <div id="ai-chat-popup-disclaimer">
                <div id="ai-disclaimer-content">
                    <span id="ai-disclaimer-close" class="disclaimerContentToggle"></span>
                    <p>The Tool is powered by ChatGPT; Outputs are based on information available on this website only, however, may include errors; the Tool is intended for general knowledge purposes and to facilitate easier accessibility to Company's services only; The Tool does not constitute an investment advice nor a recommendation; Since the Tool is powered by 3rd party, users must refrain from uploading any of their personal data while using it. The Company will bear no responsibility or liability in respect of processing such data.</p>
                </div>
            </div>
        </div>
       
    </div>
`;

export function loadChatPopup(elem){
    elem.appendChild(chat_popup);
}


